import React, {useState} from 'react';
import {View, StyleSheet, Text} from 'react-native';
import Themes from '../../themes';
import FormCSTA from '../../form/FormCSTA';
import TitleBlock from '../../components/TitleBlock';

const SimuCSTA = ({navigation}) => {
  const [CSTA, setCSTA] = useState(0);
  const [ITPER, setITPER] = useState(0);
  const [total, setTotal] = useState(0);

  const form = (
    <View style={[styles.scene]}>
      <FormCSTA setITPER={setITPER} setCSTA={setCSTA} setTotal={setTotal} />
    </View>
  );

  const results = (
    <View style={[styles.scene]}>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>Montant CSTA</Text>
        <Text style={[styles.result]}>{CSTA}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>Montant ITPER</Text>
        <Text style={[styles.result]}>{ITPER}</Text>
      </View>
    </View>
  );

  return (
    <>
      <TitleBlock
        bgColor={Themes.colors.lightPurple}
        textColor="white"
        image={require('../../assets/home-icon-home.png')}>
        CALCUL DE LA CST-A ET ITPER
      </TitleBlock>
      {form}
      {results}
    </>
  );
};

const styles = StyleSheet.create({
  scene: {
    flex: 1,
    padding: 20,
  },
  resultItem: {
    flexDirection: 'row',
    borderBottomWidth: 3,
    paddingVertical: 3,
    borderBottomColor: Themes.colors.lightBlue,
    borderStyle: 'dashed',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    flex: 1,
    flexGrow: 2,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
  },
  result: {
    flex: 1,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
    textAlign: 'right',
  },
});

export default SimuCSTA;
